var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotizacion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.801,
    height: 19.801,
    viewBox: "0 0 19.801 19.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fffbf3;\n      }\n\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cash-coin",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7872",
    "data-name": "Path 7872",
    className: "cls-1",
    d: "M15.9,23.821A7.92,7.92,0,1,0,7.98,15.9a7.92,7.92,0,0,0,7.92,7.92m9.9-7.92A9.9,9.9,0,1,1,15.9,6a9.9,9.9,0,0,1,9.9,9.9",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7873",
    "data-name": "Path 7873",
    className: "cls-2",
    d: "M9.439,15.319c.093,1.18,1.026,2.1,2.7,2.21V18.4h.743v-.877c1.733-.121,2.744-1.047,2.744-2.39,0-1.224-.772-1.853-2.158-2.178l-.586-.139V10.44a1.387,1.387,0,0,1,1.329,1.053h1.3A2.506,2.506,0,0,0,12.88,9.369V8.5h-.743v.891a2.425,2.425,0,0,0-2.485,2.293c0,1.113.748,1.822,1.994,2.111l.491.121v2.519a1.5,1.5,0,0,1-1.378-1.115H9.437Zm2.693-2.681c-.731-.168-1.127-.515-1.127-1.034a1.2,1.2,0,0,1,1.133-1.144v2.178Zm.855,1.477c.889.206,1.3.539,1.3,1.127,0,.671-.509,1.131-1.4,1.216V14.092Z",
    transform: "translate(3.369 2.45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotizacion);
export default __webpack_public_path__ + "static/media/cotizacion.961ca2faf2f62ccc70a883747d2b5fbb.svg";
export { ForwardRef as ReactComponent };